import React from "react";
import ModalUserFlowCases from "./ModalUserFlowCases";
import { useSelector } from "react-redux";
import { TYPE_USER } from "../helper/const";
// import bgPopupWelcome from "../assets/images/whell-type-03.png";
import bgPopupWelcome from "../assets/web-v3-images/free-bid-popup-bg.png";
import bgPopupNewUserOffer from "../assets/images/whell-type-new-user-offer.png";

// => chỉ show case 1 và 3: newNoPackage and newPackage
export default function ComponentModalLayout({ onClose, onNeverShow }) {
  const { typeIntroTour } = useSelector((state) => state.reducerHome);

  // cases không cần hiển thị popup: 2, 6
  // show bg popup welcome to shwedeal
  if (
    +typeIntroTour?.typeActive === TYPE_USER.newNoPackage ||
    +typeIntroTour?.typeActive === TYPE_USER.newPackage
  ) {
    return (
      <ModalUserFlowCases
        backgroundImage={bgPopupWelcome}
        onClose={onClose}
        onNeverShow={onNeverShow}
      />
    );
  }

  // cases không cần hiển thị popup: 4 và 5
  // if (
  //   +typeIntroTour?.typeActive === TYPE_USER.firstLoginAfterRegistered7Days ||
  //   +typeIntroTour?.typeActive === TYPE_USER.firstLoginWithinRegistered2To6Days
  // ) {
  //   return (
  //     <ModalUserFlowCases
  //       backgroundImage={bgPopupNewUserOffer}
  //       onClose={onClose}
  //       onNeverShow={onNeverShow}
  //     />
  //   );
  // }

  return <></>;
}
